import 'css-chunksrc/client/scenes/taskCompletion/styles.scss';export default {
  "header": "_header_16jrf_1",
  "title": "_title_16jrf_5",
  "main": "_main_16jrf_11",
  "buttons": "_buttons_16jrf_21",
  "confirmButton": "_confirmButton_16jrf_31",
  "section": "_section_16jrf_41",
  "label": "_label_16jrf_50"
};